var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.1481 13H15.9356V4.25H14.0606V13H3.84808C3.78369 13.4639 3.75028 13.9316 3.74808 14.4V23C3.6754 23.5094 3.7223 24.0287 3.88505 24.5168C4.04781 25.0049 4.32195 25.4485 4.68579 25.8123C5.04962 26.1761 5.49315 26.4503 5.98127 26.613C6.46939 26.7758 6.9887 26.8227 7.49808 26.75H22.4981C23.0075 26.8227 23.5268 26.7758 24.0149 26.613C24.503 26.4503 24.9465 26.1761 25.3104 25.8123C25.6742 25.4485 25.9484 25.0049 26.1111 24.5168C26.2739 24.0287 26.3208 23.5094 26.2481 23V14.4C26.2459 13.9316 26.2125 13.4639 26.1481 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07266 4.25H14.0602V13H3.84766C3.91349 12.5441 4.00953 12.0931 4.13516 11.65L5.47266 6.975C5.93516 5.3625 6.24766 4.25 9.07266 4.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1461 13H15.9336V4.25H20.9211C23.7461 4.25 24.0586 5.3625 24.5211 6.975L25.8586 11.65C25.9842 12.0931 26.0803 12.5441 26.1461 13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4961 22.6875H8.74609C8.49745 22.6875 8.259 22.5887 8.08318 22.4129C7.90737 22.2371 7.80859 21.9986 7.80859 21.75C7.80859 21.5014 7.90737 21.2629 8.08318 21.0871C8.259 20.9113 8.49745 20.8125 8.74609 20.8125H12.4961C12.7447 20.8125 12.9832 20.9113 13.159 21.0871C13.3348 21.2629 13.4336 21.5014 13.4336 21.75C13.4336 21.9986 13.3348 22.2371 13.159 22.4129C12.9832 22.5887 12.7447 22.6875 12.4961 22.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.f0d93482713dd54513bd596d6ee6a8f8.svg";
export { ForwardRef as ReactComponent };